module.exports = __webpack_public_path__ + "img/bike-man.b2c10458.png";